import { merge } from '@/helpers/Utility';
import { FC } from 'react';

interface CalendarHeaderProps {
  date: Date;
}

export const CalendarHeader: FC<CalendarHeaderProps> = ({ date }) => {
  const today = date.toDateString() === new Date().toDateString();

  return (
    <div className={merge(`w-full pl-1 font-bold`, today ? 'border border-gray-700 rounded-lg' : 'border-b-2')}>
      <div className={`rounded w-min px-1`}>{date.getDate()}</div>
    </div>
  );
};
